'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var WinresLoginController = function () {
  function WinresLoginController($rootScope, userService) {
    _classCallCheck(this, WinresLoginController);

    this.$rootScope = $rootScope;
    this.userService = userService;

    // The status of the login form. Possible values:
    // init - Initializing.
    // out - Show the form. Ready to log in.
    // logging-in - In process of logging in.
    // in - Logged in.
    // logging-out - In process of logging out.
    this.status = 'init';

    // An error code, if applicable. Null if no error.
    this.error = null;

    // The credentials
    this.username = '';
    this.password = '';
  }

  _createClass(WinresLoginController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      var alreadyLoggedIn = !!this.userService.getCurrentUser();
      this.status = alreadyLoggedIn ? 'in' : 'out';
      this.$rootScope.$on('login', function () {
        return _this.status = 'in';
      });
      this.$rootScope.$on('logout', function () {
        return _this.status = 'out';
      });
    }
  }, {
    key: 'showLogin',
    value: function showLogin() {
      return _.includes(['out', 'logging-in'], this.status);
    }
  }, {
    key: 'showLogout',
    value: function showLogout() {
      return _.includes(['in', 'logging-out'], this.status);
    }
  }, {
    key: 'login',
    value: function login() {
      var _this2 = this;

      this.error = null;
      this.status = 'logging-in';
      var q = this.userService.login(this.username, this.password, this.connectionName);
      q.then(function (result) {
        if (!result) {
          _this2.status = 'out';
          _this2.error = 'login-invalid';
        }
      }, function (error) {
        _this2.status = 'out';
        _this2.error = 'login-failed';
      });
    }
  }, {
    key: 'logout',
    value: function logout() {
      this.status = 'logging-out';
      this.userService.logout();
    }
  }]);

  return WinresLoginController;
}();

WinresLoginController.$inject = ['$rootScope', 'userService'];

_module3.default.component('winresLogin', {
  template: require('./winresLogin.html'),
  controller: WinresLoginController,
  require: {},
  bindings: {
    connectionName: '@'
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresLogin/winresLogin.js
// module id = 311
// module chunks = 2